import { PermissionSetDomain } from '../../../types';

export interface DomainConfig {
  key: PermissionSetDomain;
  label: string;
  // entity_type for the custom-field-definitions API; null skips the account-aware fetch.
  customFieldEntityType: string | null;
  // Whether PermissionSets::RecordScoper actually scopes this domain by tag; the api rejects record_scope "tag" on the rest.
  tagScopable: boolean;
}

// ⚠️ `tagScopable` is a hand-maintained mirror of upstack_api `PermissionSet.tag_scopable_domains` (derived there from `PermissionSets::RecordScoper::DOMAIN_CONFIG`, served by no endpoint): a domain the scoper learns must be flipped here by hand or the portal keeps hiding an option the api now accepts.
export const PERMISSION_SET_DOMAINS: DomainConfig[] = [
  { key: 'inventory', label: 'Inventory', customFieldEntityType: 'Inventory', tagScopable: true },
  { key: 'projects', label: 'Projects', customFieldEntityType: 'Project', tagScopable: true },
  { key: 'orders', label: 'Orders', customFieldEntityType: null, tagScopable: true },
  { key: 'cases', label: 'Cases', customFieldEntityType: null, tagScopable: false },
  { key: 'reports', label: 'Reports', customFieldEntityType: null, tagScopable: false }
];

export const getDomainConfig = (key: PermissionSetDomain): DomainConfig | undefined =>
  PERMISSION_SET_DOMAINS.find((domain) => domain.key === key);
